import React from 'react';
import { node, string } from 'prop-types';
import styles from './DefaultPreamble.module.scss';

const DefaultPreamble = (props) => {
  const { children, className } = props;
  return (
    <p
      {...props}
      className={[styles.defaultPreamble, className].join(' ')}
    >
      {children}
    </p>
  );
};

DefaultPreamble.propTypes = {
  children: node,
  className: string,
};

DefaultPreamble.defaultProps = {
  children: null,
  className: null,
};

export default DefaultPreamble;
